/* eslint-disable-next-line */
export interface BillingSettingsProps {}

export function BillingSettings(props: BillingSettingsProps) {
  return (
    <div>
      <h1>Welcome to BillingSettings!</h1>
    </div>
  );
}

export default BillingSettings;
